"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertStyled = exports.AlertMessageStyled = exports.AlertIconWrapperStyled = exports.AlertBodyStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Paragraph = _interopRequireDefault(require("../../Paragraph/styled/Paragraph"));
var _styled = require("../constants/styled");
var AlertStyled = exports.AlertStyled = _styledComponents.default.div.withConfig({
  displayName: "Alert__AlertStyled",
  componentId: "sc-16wa3yo-0"
})(["", " border-radius:6px;margin-top:16px;position:relative;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.clearfix;
}, function (_ref2) {
  var theme = _ref2.theme,
    type = _ref2.type;
  switch (type) {
    case 'error':
      return "\n          border: 1px solid ".concat(theme.color.dangerDark, ";\n          background-color: ").concat(theme.color.dangerLighter, ";\n        ");
    case 'info':
      return "\n          border: 1px solid ".concat(theme.color.infoDark, ";\n          background-color: ").concat(theme.color.infoLighter, ";\n        ");
    default:
      return "\n          border: 1px solid ".concat(theme.color.success, ";\n          background-color: ").concat(theme.color.successLighter, ";\n        ");
  }
});
var AlertBodyStyled = exports.AlertBodyStyled = _styledComponents.default.div.withConfig({
  displayName: "Alert__AlertBodyStyled",
  componentId: "sc-16wa3yo-1"
})(["display:table;padding:16px 24px;width:100%;box-sizing:border-box;"]);
var AlertIconWrapperStyled = exports.AlertIconWrapperStyled = _styledComponents.default.div.withConfig({
  displayName: "Alert__AlertIconWrapperStyled",
  componentId: "sc-16wa3yo-2"
})(["display:table-cell;padding-right:16px;vertical-align:middle;width:", "px;"], _styled.ICON_DIMENSION);
var AlertMessageStyled = exports.AlertMessageStyled = (0, _styledComponents.default)(_Paragraph.default).withConfig({
  displayName: "Alert__AlertMessageStyled",
  componentId: "sc-16wa3yo-3"
})(["color:", ";display:table-cell;font-size:14px;font-weight:bold;line-height:20px;margin-bottom:0;vertical-align:middle;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.charcoal;
});